<template>
  <div>
    <div class="">
      <b-container class="container-box">
        <b-tabs content-class="mt-0">
          <b-tab
            v-for="(item, index) in productBranchs"
            :key="index"
            @click="onChangeBranchSelected(index)"
          >
            <template v-slot:title>
              <div class="img-upload">
                <div
                  class="img-upload-display"
                  v-bind:style="{
                    backgroundImage: 'url(' + item.pictureUrl + ')',
                  }"
                ></div>
              </div>
              <p class="mb-0 tab-store-name">{{ item.salesChannalName }}</p>
            </template>
          </b-tab>
        </b-tabs>
        <div class="d-flex flex-row w-100 header-purple">
          <div class="w-100"><p class="mb-0">ข้อมูลทั่วไป</p></div>
          <div class="w-100">
            <p class="mb-0 d-flex justify-content-end">
              อัพเดทล่าสุด :
              {{ new Date() | moment($formatDateTime) }}
            </p>
          </div>
        </div>
        <div class="p-4 bg-white">
          <b-row class="no-gutters">
            <b-col>
              <div class="">
                <InputText
                  textFloat="ชื่อสินค้า"
                  placeholder="ชื่อสินค้า"
                  type="text"
                  name="productName"
                  class="pr-1"
                  v-model="productBranchSelected.branchDetail.product.name"
                  isRequired
                  :isValidate="
                    $v.productBranchSelected.branchDetail.product.name.$error
                  "
                  :v="$v.productBranchSelected.branchDetail.product.name"
                />
              </div>
            </b-col>
            <b-col>
              <div class="">
                <InputText
                  textFloat="Parent SKU"
                  placeholder="Parent SKU"
                  type="text"
                  name="parentSKU"
                  v-model="productBranchSelected.branchDetail.product.sku"
                  isRequired
                  :disabled="true"
                />
              </div>
            </b-col>
          </b-row>

          <div class="w-100">
            <TextEditor
              textFloat="รายละเอียดสินค้า"
              v-model="productBranchSelected.branchDetail.product.description"
              placeholder="รายละเอียดสินค้า"
              :rows="8"
              isRequired
              :name="'prodetail-description'"
              @onDataChange="
                (val) =>
                  (productBranchSelected.branchDetail.product.description = val)
              "
              :isValidate="
                $v.productBranchSelected.branchDetail.product.description.$error
              "
              :v="$v.productBranchSelected.branchDetail.product.description"
            />
          </div>
          <template
            v-if="productBranchSelected.branchDetail.productTypeId == 1"
          >
            <b-row class="no-gutters">
              <b-col>
                <div class="">
                  <InputText
                    textFloat="ราคาป้าย (บาท)"
                    placeholder="ราคาป้าย (บาท)"
                    type="text"
                    name="productPrice"
                    v-model="productBranchSelected.branchDetail.product.price"
                    isRequired
                    :isValidate="
                      $v.productBranchSelected.branchDetail.product.price.$error
                    "
                    :v="$v.productBranchSelected.branchDetail.product.price"
                    class="pr-1"
                  />
                </div>
              </b-col>
              <b-col>
                <div class="">
                  <InputText
                    textFloat="ราคาขาย (บาท)"
                    placeholder=""
                    type="number"
                    name="productSellPrice"
                    isRequired
                    v-model="
                      productBranchSelected.branchDetail.product.advancePrice
                        .priceAfterDiscount
                    "
                    :isValidate="
                      $v.productBranchSelected.branchDetail.product.advancePrice
                        .priceAfterDiscount.$error
                    "
                    :v="
                      $v.productBranchSelected.branchDetail.product.advancePrice
                        .priceAfterDiscount
                    "
                  />
                </div>
              </b-col>
            </b-row>
            <b-row class="no-gutters">
              <b-col>
                <div class="pr-1">
                  <label class="font-weight-bold">
                    วันเริ่มต้นของราคาขาย (วว/ดด/ปปปป)
                    <span class="text-danger">*</span>
                  </label>
                  <div :class="['input-container']">
                    <datetime
                      :input-style="styleDatetime"
                      v-model="
                        productBranchSelected.branchDetail.product.advancePrice
                          .startDate
                      "
                      placeholder="วว / ดด / ปป"
                      ref="startCampaignDate"
                    >
                    </datetime>
                    <div
                      class="icon-container text-right"
                      @click="$refs.startCampaignDate.isOpen = true"
                    >
                      <font-awesome-icon icon="calendar-alt" color="#B41BB4" />
                    </div>
                  </div>
                  <div
                    v-if="
                      $v.productBranchSelected.branchDetail.product.advancePrice
                        .startDate.$error
                    "
                  >
                    <span class="text-error">กรุณาเลือกวันที่</span>
                  </div>
                </div>
              </b-col>
              <b-col>
                <div class="">
                  <label class="font-weight-bold">
                    วันสิ้นสุดของราคาขาย (วว/ดด/ปปปป)
                    <span class="text-danger">*</span>
                  </label>
                  <div :class="['input-container']">
                    <datetime
                      :input-style="styleDatetime"
                      v-model="
                        productBranchSelected.branchDetail.product.advancePrice
                          .endDate
                      "
                      placeholder="วว / ดด / ปป"
                      ref="startCampaignDate"
                    >
                    </datetime>
                    <div
                      class="icon-container text-right"
                      @click="$refs.startCampaignDate.isOpen = true"
                    >
                      <font-awesome-icon icon="calendar-alt" color="#B41BB4" />
                    </div>
                  </div>
                  <div
                    v-if="
                      $v.productBranchSelected.branchDetail.product.advancePrice
                        .endDate.$error
                    "
                  >
                    <span class="text-error">กรุณาเลือกวันที่</span>
                  </div>
                </div>
              </b-col>
            </b-row>
          </template>
        </div>

        <template v-if="productBranchSelected.branchDetail.productTypeId == 2">
          <div>
            <div class="mt-2 d-flex flex-row w-100 header-purple">
              <p class="mb-0">ประเภทสินค้า</p>
            </div>

            <div class="d-flex flex-row bg-white">
              <div class="stock-section">
                <p>
                  <strong>ราคาและสต็อกสินค้า</strong>
                </p>
                <b-form-group>
                  <b-form-radio-group
                    v-model="
                      productBranchSelected.branchDetail.priceSettingFlag
                    "
                    :options="options"
                    @change="onPriceSettingFlagChange"
                    class="custom-radio"
                  ></b-form-radio-group>
                </b-form-group>
              </div>
              <div class="input-price-section bg-white d-flex flex-row">
                <InputText
                  v-if="forceRefresh"
                  textFloat=""
                  placeholder="ราคา"
                  type="text"
                  name="customPrice"
                  v-model="productBranchSelected.branchDetail.priceSettingValue"
                  @onKeyup="onPriceSettingValueDefaultChange"
                  @onKeypress="isNumber($event)"
                  :disabled="
                    productBranchSelected.branchDetail.priceSettingFlag == 1
                  "
                />
              </div>
            </div>

            <div class="bg-white px-3">
              <CombinationTable
                :advancePriceData="
                  productBranchSelected.branchDetail.product.advancePrice
                "
                :dataObject="
                  productBranchSelected.branchDetail.product.children
                "
                :attributes="
                  productBranchSelected.branchDetail.product.attributes
                "
                :v="
                  $v.productBranchSelected.branchDetail.product.children
                    .attributeOption
                "
                :isDisable="true"
                :isDisableSKU="true"
                :isDisableBarcode="true"
                :isDisablePrice="true"
                :isDisableAdvancePrice="
                  productBranchSelected.branchDetail.priceSettingFlag == 1
                "
              />
            </div>
          </div>
          <div class="d-flex flex-row w-100 bg-white px-4 pb-3">
            <div class="w-100 pr-1">
              <label class="font-weight-bold">
                วันเริ่มต้นของราคาขาย (วว/ดด/ปปปป)
                <span class="text-danger">*</span>
              </label>
              <div :class="['input-container']">
                <datetime
                  :input-style="styleDatetime"
                  v-model="
                    productBranchSelected.branchDetail.product.advancePrice
                      .startDate
                  "
                  placeholder="วว / ดด / ปป"
                  ref="startCampaignDate"
                >
                </datetime>
                <div
                  class="icon-container text-right"
                  @click="$refs.startCampaignDate.isOpen = true"
                >
                  <font-awesome-icon icon="calendar-alt" color="#B41BB4" />
                </div>
              </div>
              <div
                v-if="
                  $v.productBranchSelected.branchDetail.product.advancePrice
                    .startDate.$error
                "
              >
                <span class="text-error">กรุณาเลือกวันที่</span>
              </div>
            </div>
            <div class="w-100">
              <label class="font-weight-bold">
                วันสิ้นสุดของราคาขาย (วว/ดด/ปปปป)
                <span class="text-danger">*</span>
              </label>
              <div :class="['input-container']">
                <datetime
                  :input-style="styleDatetime"
                  v-model="
                    productBranchSelected.branchDetail.product.advancePrice
                      .endDate
                  "
                  placeholder="วว / ดด / ปป"
                  ref="startCampaignDate"
                >
                </datetime>
                <div
                  class="icon-container text-right"
                  @click="$refs.startCampaignDate.isOpen = true"
                >
                  <font-awesome-icon icon="calendar-alt" color="#B41BB4" />
                </div>
              </div>
              <div
                v-if="
                  $v.productBranchSelected.branchDetail.product.advancePrice
                    .endDate.$error
                "
              >
                <span class="text-error">กรุณาเลือกวันที่</span>
              </div>
            </div>
          </div>
        </template>

        <div class="mt-2">
          <div class="p-2 bg-white">
            <b-container class="p-0">
              <b-row class="no-gutters">
                <b-col md="6" class="d-flex">
                  <b-button class="btn-main-3" @click="$emit('handleRoute')"
                    >ยกเลิก</b-button
                  >
                </b-col>
                <b-col
                  md="6"
                  class="d-flex justify-content-md-end mt-3 mt-md-0"
                >
                  <!-- <b-button
                    @click="checkForm()"
                    :disabled="isDisabled"
                    class="btn-main"
                    >บันทึกแบบร่าง</b-button
                  > -->
                  <b-button
                    @click="checkForm()"
                    :disabled="isDisabled"
                    class="ml-2 btn-main"
                    >บันทึก</b-button
                  >
                </b-col>
              </b-row>
            </b-container>
          </div>
        </div>
      </b-container>
    </div>
    <ModalAlert
      ref="modalAlert"
      :text="modalMessage"
      v-on:hadleModalAlertClose="hadleModalAlertClose"
    />
    <ModalAlertError ref="modalAlertError" :text="modalMessage" />
    <ModalLoading ref="modalLoading" :hasClose="false" />
  </div>
</template>

<script>
import InputText from "@/components/inputs/InputText";
import TextEditor from "@/components/inputs/TextEditor";
import { required, numeric, requiredIf } from "vuelidate/lib/validators";
import CombinationTable from "@/views/pages/product/components/product-detail/CombinationListSection.vue";
import * as moment from "moment/moment";
import ModalAlert from "@/components/modal/alert/ModalAlert";
import ModalAlertError from "@/components/modal/alert/ModalAlertError";
import ModalLoading from "@/components/modal/alert/ModalLoading";

export default {
  components: {
    InputText,
    TextEditor,
    CombinationTable,
    ModalAlert,
    ModalAlertError,
    ModalLoading,
  },
  data() {
    return {
      modalMessage: "",
      styleDatetime: {
        width: "100%",
        border: "none",
      },
      options: [
        { text: "ค่าเริ่มต้นจาก SAP", value: 1 },
        { text: "กำหนดเอง", value: 2 },
      ],
      isDisabled: false,
      productBranchs: [],
      productBranchDetail: null,
      forceRefresh: true,
      productBranchSelected: {
        branchDetail: {
          product: {
            advancePrice: {
              price: 0.0,
              id: 0,
              productId: 0,
              branchId: 0,
              priceAfterDiscount: 0,
              startDate: "",
              endDate: "",
              enabled: true,
            },
          },
          name: "",
          description: "",
          price: 0,
          attributes: {},
          children: { attributeOption: {} },
          priceSettingFlag: 1,
          priceSettingValue: null,
        },
        salesChannelId: 0,
        salesChannalName: "",
        salesChannalTypeId: 0,
        pictureUrl: "",
        iconUrl: "",
        id: 0,
        enabled: true,
        sortOrder: 0,
        branchTypeId: 1,
        branchCode: "",
        telephone: "",
        zipcodeId: 0,
        latitude: "0",
        longtitude: "0",
        mainLanguageId: 1,
        isSameLanguage: true,
        provinceId: 0,
        districtId: 0,
        subdistrictId: 0,
        countryId: 0,
        code: "",
        brandId: 1,
        translationList: [
          {
            languageId: 1,
            name: "",
            address: "",
            operationTime: "",
          },
          {
            languageId: 2,
            name: "",
            address: "",
            operationTime: "",
          },
        ],
        user: null,
      },
      form: {
        BranchId: 0,
        MainProductId: 0,
        Name: "",
        Description: "",
        Price: 0,
        StartDate: "",
        EndDate: "",
        PriceDetail: [],
        Children: [],
      },
    };
  },

  created: async function() {
    await this.getProductBranch();
  },

  validations: {
    productBranchSelected: {
      branchDetail: {
        product: {
          name: { required },
          description: { required },
          price: { required },
          advancePrice: {
            priceAfterDiscount: { required },
            startDate: { required },
            endDate: { required },
          },
          children: {
            attributeOption: {
              $each: {
                product: {
                  price: {},
                  advancePrice: {
                    priceAfterDiscount: {},
                  },
                  sku: {},
                  barcode: {},
                  weight: {},
                  straightPrice: {},
                  rawPrice: {},
                  quantity: {},
                  gp: {},
                  translationList: {
                    $each: {
                      name: {},
                    },
                  },
                },
                attribute: {
                  attributeOption: {
                    $each: {
                      product: {
                        price: {},
                        advancePrice: {
                          priceAfterDiscount: {},
                        },
                        sku: {},
                        barcode: {},
                        weight: {},
                        straightPrice: {},
                        rawPrice: {},
                        translationList: {
                          $each: {
                            name: {},
                          },
                        },
                      },
                      attribute: {
                        attributeOption: {
                          $each: {
                            product: {
                              price: {},
                              advancePrice: {
                                priceAfterDiscount: {},
                              },
                              sku: {},
                              barcode: {},
                              weight: {},
                              straightPrice: {},
                              rawPrice: {},
                              translationList: {
                                $each: {
                                  name: {},
                                },
                              },
                            },
                          },
                        },
                      },
                    },
                  },
                },
              },
            },
          },
        },
        priceSettingValue: {},
      },
    },
  },
  methods: {
    isNumber: function(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;

      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    onChangeBranchSelected(index) {
      this.getProductBranchDetail(this.productBranchs[index].id, index);
    },
    onPriceSettingFlagChange(value) {
      this.forceRefresh = false;
      this.$nextTick(() => {
        this.productBranchSelected.branchDetail.priceSettingFlag = value;
        this.forceRefresh = true;
      });
    },
    onPriceSettingValueDefaultChange() {
      this.productBranchSelected.branchDetail.product.children.attributeOption.forEach(
        (element) => {
          if (element.attribute) {
            element.attribute.attributeOption.forEach((element2) => {
              if (element2.attribute) {
                element2.attribute.attributeOption.forEach((element3) => {
                  element3.product.advancePrice.priceAfterDiscount = this.productBranchSelected.branchDetail.priceSettingValue;
                });
              } else {
                element2.product.advancePrice.priceAfterDiscount = this.productBranchSelected.branchDetail.priceSettingValue;
              }
            });
          } else {
            element.product.advancePrice.priceAfterDiscount = this.productBranchSelected.branchDetail.priceSettingValue;
          }
        }
      );
    },
    hadleModalAlertClose() {
      this.getProductBranch();
    },
    async getProductBranch() {
      await this.axios
        .get(`${this.$baseUrl}/product/Branch/${this.$route.params.id}`)
        .then(async (data) => {
          this.productBranchs = data.detail.branchs.map((el) => {
            return {
              ...el,
              branchDetail: {},
            };
          });
          await this.getProductBranchDetail(data.detail.branchs[0].id, 0);
        });
    },
    async getProductBranchDetail(branchId, index) {
      await this.axios
        .get(
          `${this.$baseUrl}/product/BranchDetail?productId=${this.$route.params.id}&branchId=${branchId}`
        )
        .then(async (data) => {
          this.productBranchs[index].branchDetail = data.detail;
          this.productBranchs[index].branchDetail.priceSettingFlag = 1;
          await this.onSetBranchSelected(this.productBranchs[index]);
        });
    },
    onSetBranchSelected: async function(productBranch) {
      this.productBranchSelected = productBranch;
      if (!this.productBranchSelected.branchDetail.product.advancePrice) {
        if (this.productBranchSelected.branchDetail.productTypeId == 1) {
          this.productBranchSelected.branchDetail.product.advancePrice = {
            price: 0.0,
            id: 0,
            productId: this.$route.params.id,
            branchId: this.productBranchSelected.id,
            priceAfterDiscount: 0,
            startDate: moment().format(),
            endDate: moment()
              .add("day", 1)
              .format(),
            enabled: true,
          };
        } else {
          this.productBranchSelected.branchDetail.product.advancePrice = {
            price: 0.0,
            id: 0,
            productId: this.$route.params.id,
            branchId: this.productBranchSelected.id,
            priceAfterDiscount: 0,
            startDate: moment().format(),
            endDate: moment()
              .add("day", 1)
              .format(),
            enabled: true,
          };
        }
      }
      await this.onSetProductAdvancePrice();
    },
    onSetProductAdvancePrice() {
      if (this.productBranchSelected.branchDetail.productTypeId == 2) {
        this.productBranchSelected.branchDetail.product.children.attributeOption.forEach(
          (element) => {
            if (element.attribute) {
              element.attribute.attributeOption.forEach((element2) => {
                if (element2.attribute) {
                  element2.attribute.attributeOption.forEach((element3) => {
                    if (element3.product.advancePrice.priceAfterDiscount == 0) {
                      element3.product.advancePrice.priceAfterDiscount = null;
                    }
                  });
                } else {
                  if (element2.product.advancePrice.priceAfterDiscount == 0) {
                    element2.product.advancePrice.priceAfterDiscount = null;
                  }
                }
              });
            } else {
              if (element.product.advancePrice.priceAfterDiscount == 0) {
                element.product.advancePrice.priceAfterDiscount = null;
              }
            }
          }
        );
      }
    },
    onSetForm() {
      //set advanceprice date for product config
      let PriceDetail = [];
      if (this.productBranchSelected.branchDetail.productTypeId == 2) {
        this.productBranchSelected.branchDetail.product.children.attributeOption.forEach(
          (element) => {
            if (element.attribute) {
              element.attribute.attributeOption.forEach((element2) => {
                if (element2.attribute) {
                  element2.attribute.attributeOption.forEach((element3) => {
                    PriceDetail.push({
                      ProductId: element3.product.id,
                      PriceAfterDiscount: element3.product.advancePrice
                        .priceAfterDiscount
                        ? element3.product.advancePrice.priceAfterDiscount
                        : null,
                    });
                  });
                } else {
                  PriceDetail.push({
                    ProductId: element2.product.id,
                    PriceAfterDiscount: element2.product.advancePrice
                      .priceAfterDiscount
                      ? element2.product.advancePrice.priceAfterDiscount
                      : null,
                  });
                }
              });
            } else {
              PriceDetail.push({
                ProductId: element.product.id,
                PriceAfterDiscount: element.product.advancePrice
                  .priceAfterDiscount
                  ? element.product.advancePrice.priceAfterDiscount
                  : null,
              });
            }
          }
        );
      }

      const form = {
        BranchId: this.productBranchSelected.id,
        MainProductId: this.productBranchSelected.branchDetail.product
          .productId,
        Name: this.productBranchSelected.branchDetail.product.name,
        Description: this.productBranchSelected.branchDetail.product
          .description,
        Price: this.productBranchSelected.branchDetail.product.price,
        StartDate: this.productBranchSelected.branchDetail.product.advancePrice
          .startDate,
        EndDate: this.productBranchSelected.branchDetail.product.advancePrice
          .endDate,
        PriceDetail: PriceDetail,
        PriceSettingFlag: this.productBranchSelected.branchDetail
          .priceSettingFlag,
        PriceSettingValue: this.productBranchSelected.branchDetail
          .priceSettingValue,
      };

      this.form = form;
    },
    checkForm: async function() {
      this.$v.productBranchSelected.$touch();
      if (this.$v.productBranchSelected.$error) {
        return;
      }
      this.isDisabled = true;
      this.$refs.modalLoading.show();
      await this.onSetForm();
      await this.onSubmitForm();
    },
    onSubmitForm: async function() {
      await this.axios
        .put(`${this.$baseUrl}/product/BranchDetail`, this.form)
        .then((data) => {
          this.isDisabled = false;
          if (data.result == 1) {
            this.modalMessage = "สำเร็จ";
            this.$refs.modalLoading.hide();
            this.$refs.modalAlert.show();
          } else {
            this.modalMessage = data.message;
            this.$refs.modalLoading.hide();
            this.$refs.modalAlertError.show();
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  padding: 0;
}
.header-purple {
  padding: 1rem;
  background: #e0e1f4;
  font-weight: bold;
}
.stock-section {
  padding: 1rem 1rem 0.5rem 1rem;
}
// /deep/ .custom-control-inline {
//   margin-right: 4rem !important;
// }
.button-container {
  min-width: 150px;
}
.img-market {
  width: 70px;
  padding-bottom: 100.5%;
  background-size: contain;
  background-position: top;
  background-repeat: no-repeat;
}
.container-img-market {
  height: 50px;
  padding-top: 3px;
}
.img-upload {
  margin-right: auto;
  height: 50%;
  max-height: 20rem;
  width: 100%;
  max-width: 30rem;
  display: flex;
  justify-content: center;
}
.img-upload-display {
  width: 100%;
  padding-bottom: 15%;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  background-color: inherit !important;
}
.tab-store-name {
  font-size: 12px;
}
/deep/ .nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  border: 0px !important;
  background-color: #e0e1f4;
  color: #092d53 !important;
  overflow-x: hidden;
}
/deep/ .nav-tabs .nav-link {
  border-bottom: 0px;
}
/deep/ ::-webkit-scrollbar {
  display: none !important;
}
.input-price-section {
  padding-top: 2.5rem;
}
.header-purple {
  padding: 1rem;
  background: #e0e1f4;
  font-weight: bold;
}
// input datetime
.input-container {
  display: flex;
  padding: 0.5rem;
  border: 1px solid #bcbcbc;
  border-radius: 4px;
  align-items: center;
  justify-content: space-between;
}
.input-container.error {
  border-color: red !important;
}
.icon-container {
  flex: 1 1 auto;
  cursor: text;
}
.text-error {
  color: #ff0000;
  font-size: 14px;
}
// end input datetime
</style>
